import React from 'react'
import { useTranslation } from 'react-i18next'

const FeaturesSection: React.FC = () => {
    const { t } = useTranslation()
    const features: string[] = t('features.list', { returnObjects: true })

    return (
        <section style={{ padding: '60px 20px', backgroundColor: '#f4f2e8' }}>
            <h2 style={{ textAlign: 'center', fontSize: '2rem' }}>
                {t('features.title')}
            </h2>
            <ul
                style={{
                    maxWidth: 800,
                    margin: '30px auto',
                    listStyle: 'none',
                    padding: 0
                }}
            >
                {features.map((item, index) => (
                    <li
                        key={index}
                        style={{ marginBottom: '15px', fontSize: '1.1rem' }}
                    >
                        ✅ <strong>{item}</strong>
                    </li>
                ))}
            </ul>
        </section>
    )
}

export default FeaturesSection
